"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPTION_TYPES = void 0;
var OPTION_TYPES = exports.OPTION_TYPES = {
  CHECKMARK: 'checkmark',
  CLOSE: 'close'
};
//# sourceMappingURL=constants.js.map